import AWSService from "../../services/AWSService";
import { getErrorMessage } from "../../helpers/functions";

export const s3Upload = async (
  file,
  field,
  setFieldValue,
  setFieldError,
  setLoader,
) => {
  if (file) {
    try {
      setLoader({ state: true, message: `Uploading file ${file.name} ...` });

      const payload = { key: file.name };
      const s3Response = await AWSService.getS3URL(payload);

      if (s3Response.url) {
        const res = await AWSService.uploadToS3(s3Response.url, file);
        setFieldValue(field, res);
      }
    } catch (error) {
      const message = getErrorMessage(error);
      setFieldError(field, message);
    } finally {
      setLoader({ state: false });
    }
  }
};
